import { useState } from "react";

const faqs = [
  {
    q: "樱花动漫在线主要提供哪些内容？",
    a: "本站把当季新番排期、最新话更新记录、连载追番进度与分类检索整理在一页之内。你可以先看本周新番排期，再浏览最新话看点，最后按题材筛选出想追的作品。",
  },
  {
    q: "本周新番应该怎么看？",
    a: "本周新番按周一至周日归类，切换到对应日期即可看到当天播出的作品。若只想了解整体情况，保持「全部」即可看到本季收录的全部新番。",
  },
  {
    q: "更新和最新话是同一个概念吗？",
    a: "略有区别。「更新」更偏向播出节奏本身，包含播出日与更新时段；「最新话」则具体指某一集更新到了第几话、这一集讲了什么。两者一起看能更快判断要不要立刻补番。",
  },
  {
    q: "追番和连载有什么区别？",
    a: "连载描述作品的播出状态，表示尚未完结、仍在按周更新；追番则是观众自己的行为，指持续关注某部作品。本站用连载进度条展示前者，用追番人气展示后者的热度。",
  },
  {
    q: "页面上的评分和追番人数是真实数据吗？",
    a: "页面中的评分、追番人数与榜单排名均为展示用途的整理数据，用于帮助理解热度层级，具体数值应以各作品官方与播出平台公布的信息为准。",
  },
  {
    q: "每天的更新时段是什么时候？",
    a: "本站以晚间更新为主，多数新番集中在 18:00 至 22:30 之间。实际播出时间可能因档期调整而变化，建议以当周的播出排期为准。",
  },
  {
    q: "分类检索能按什么条件筛选？",
    a: "可以按题材标签筛选，也可以输入作品名、日文名或关键词进行本地搜索，还能勾选「只看连载中」。所有筛选只作用于本页已收录的条目，结果会即时刷新。",
  },
];

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[minmax(0,360px)_minmax(0,1fr)] lg:gap-14">
          <div>
            <span className="text-sm font-medium text-primary-600">常见问题</span>
            <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">关于新番、更新与追番的疑问</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
              这里整理了大家最常问的几个问题，覆盖新番排期、更新时段、追番与连载的区别，以及本站数据的说明。点击任意问题即可展开答案。
            </p>
            <div className="mt-6 rounded-lg border border-accent-200 bg-accent-50 p-4">
              <p className="flex items-center gap-2 text-sm font-medium text-accent-900">
                <i className="ri-lightbulb-line"></i>
                想更快找到作品？
              </p>
              <p className="mt-2 text-xs leading-relaxed text-accent-900/85">
                直接前往分类检索，用题材标签或关键词筛选，比逐个翻看排期更高效。
              </p>
              <a
                href="#catalog"
                className="mt-3 inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-accent-500 px-3 py-2 text-xs font-medium text-background-50 transition-colors hover:bg-accent-600"
              >
                前往分类检索
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <div key={faq.q} className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    className="flex w-full items-center justify-between gap-4 p-4 text-left"
                  >
                    <span className="text-sm font-medium text-foreground-950 md:text-base">{faq.q}</span>
                    <i
                      className={`shrink-0 text-xl text-primary-600 transition-transform ${
                        isOpen ? "ri-subtract-line" : "ri-add-line"
                      }`}
                    ></i>
                  </button>
                  <p
                    className={`border-t border-background-200 px-4 py-3 text-sm leading-relaxed text-foreground-700 ${
                      isOpen ? "" : "hidden"
                    }`}
                  >
                    {faq.a}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}